import {
	Component, Input, Output, OnChanges, SimpleChanges,
	SimpleChange, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { NavigationService } from '../../../services/navigation.service';
import { MessageService } from 'base';
import { NetFacadeService } from '../../../services/netfacade.service';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { NetViewDto, NetViewTreeNodeDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { DisplayDeviceListDto, DisplayDeviceListEntryDto, GetDeviceResultDto } from 'UvExplorerServer.Dtos.TS/Session';
import { IdentityService } from 'identity';
import { DeviceSelectorEntry } from '../../device-selector/device-selector.component';
import { Network, Device, IfKey } from 'DiscoveryEngine.TS/Core';
import { UserLink, UserLinkMember } from 'DiscoveryEngine.TS/Discovery';
//import { IfTable, IfEntry } from "DiscoveryEngine.TS/InfoSets";
import { DiscResultsService } from 'discovery';
import { ValueEncoder } from "DiscoveryEngine.TS/Utils/ValueEncoder";
import { DtoBase } from "DiscoveryEngine.TS/Utils";
import { List } from "DiscoveryEngine.TS/Utils";
import { IfEntry } from 'DiscoveryEngine.TS/InfoSets/IfTable';


@Component({
	selector: 'new-user-link-dialog',
	templateUrl: './newuserlink.component.html',
    styleUrls: ['./newuserlink.component.scss']
})
export class NewUserLinkDialogComponent {

    @Input() public target: NetViewTreeNodeDto;
    @Input() display: boolean = false;
    @Output() onSuccess = new EventEmitter();
    @Output() onClose = new EventEmitter();

    currentlySelecting: number = 0;
    ifListOne = [];
    ifListTwo = [];


    deviceOne: Device = new Device(new Network);
    deviceTwo: Device = new Device(new Network);
    //deviceOne: Device;
    //deviceTwo: Device;
    ifOne: IfEntry; //= new IfEntry();
    ifTwo: IfEntry; //= new IfEntry();

    showSelector: Boolean = false;

    constructor(
        private navService: NavigationService,
        private netFacadeService: NetFacadeService,
        private messageService: MessageService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private changeDetector: ChangeDetectorRef) {

		return;
    }

    get devicesSelected(): boolean {
        return (this.deviceOne.HasGUID && this.deviceTwo.HasGUID);
    }

	public onOk(devices: DisplayDeviceListEntryDto[]): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		let deviceGuids = new List<string>();
		deviceGuids.Add(devices[0].deviceGuid);

		this.discResultsService.getDevice(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
			schedDiscRsltGuid, "network", deviceGuids, true).subscribe(
			(result: GetDeviceResultDto) => {
				if (result.HasDevices) {
					let dev: Device = result.Devices.Get(0);
					//console.log(dev);
					if (this.currentlySelecting == 1) {
						this.deviceOne = dev;
                        if (dev.HasIfTable) {
                            this.ifListOne = dev.IfTable.ToLinkableArray();
							//console.log(this.ifListOne);
						}
					}
					else if (this.currentlySelecting == 2) {
						this.deviceTwo = dev;
                        if (dev.HasIfTable) {
                            this.ifListTwo = dev.IfTable.ToLinkableArray()
							//console.log(this.ifListTwo);
						}
					}
					else {
						console.assert(false, "ERROR - INVALID DEVICE NUMBER SELECTED");
					}

					this.changeDetector.detectChanges();
				}
				else {
					this.messageService.displayErrorMessage("Could not retrieve selected device");
				}
			},
			(error?) => {
				this.messageService.displayErrorMessage("Could not retrieve selected device");
			});
	}

	public onCancel(): void {
	}

    public ngOnChanges(changes: SimpleChanges): void {
    }

    public onDialogHide(): void {
        this.onClose.emit(true);
    }

    public addNewLink(): void {

        if (this.deviceOne == undefined || this.deviceTwo == undefined) {
            return;
        }    

        var memberOne = new UserLinkMember(this.deviceOne, this.ifOne);
        var memberTwo = new UserLinkMember(this.deviceTwo, this.ifTwo);


        this.populateObjectData(memberOne);
        this.populateObjectData(memberTwo);

        var newLink = new UserLink();
        newLink.AddMember(memberOne);
        newLink.AddMember(memberTwo);

        // Populates GUID, creation time, and modified time for the new object
        this.populateObjectData(newLink);

        this.target.UserLinks.Add(newLink);

        this.reset();

        this.target.HasChanges = true;
        this.onSuccess.emit();       
    }

    public displayDialog() {
        this.display = true;
    }

    public hideDialog() {
        this.display = false;
    }

    public showDeviceList(num:number) {
        this.showSelector = true;
        this.currentlySelecting = num;
    }

    private populateObjectData(obj: DtoBase): void {
        let now = new Date();
        obj.VerifyGuid();
        obj.CreatedTime = ValueEncoder.EncodeDateTime(now);
        obj.ModifiedTime = ValueEncoder.EncodeDateTime(now);
    }


    public reset() {
        this.ifListOne = [];
        this.ifListTwo = [];


        this.deviceOne = new Device(new Network);
        this.deviceTwo = new Device(new Network);
        this.ifOne = undefined;
        this.ifTwo = undefined;
    }

}
